/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Ujjwal Singh >

*/

import React, { useEffect, useState } from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { useCookies } from "react-cookie";
import jwt from "jsonwebtoken";

import { Topbar } from "./components";
//import useVerifyLogin from 'Hooks/verify-login'
import SimpleLoader from "components/Loader/simpleLoader";

// actions
import { userLogin } from "actions/user-action";
// offlinedb
import {
  saveUserDetail,
  getUsers,
  deleteUser,
  dbExist,
} from "database/offlineDb/indexDb";
import { getNetConnectivity, updateLoginModel } from "actions/global-action";
const pathName = window.location.pathname.split("/");

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 64,
    height: "100%",
  },
  verifyLogin: { display: "none" },
  content: {
    height: "100%",
  },
}));

const Minimal = (props) => {
  const [isLogin, setIslogin] = useState(true);
  const [isLoginBtnEnable, setIsLoginBtnEnable] = useState(true);
  const [cookies, setCookie] = useCookies([]);
  const [loginErr, setLoginErr] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [login, setLogin] = React.useState(props);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  });
  const signInRef = React.useRef();

  const [checked, setChecked] = React.useState(true);

  const [isVerifyLogin, setIsVerifyLogin] = useState(true);
  const { children } = props;

  const classes = useStyles();
  const { history } = props;

  //   const isLogged=useVerifyLogin(false)
  //   useEffect(()=>{
  //     let authentication = sessionStorage.getItem('authentication')!==undefined&&sessionStorage.getItem('authentication')!==null&&sessionStorage.getItem('authentication')!==''?JSON.parse(sessionStorage.getItem('authentication')):cookies.authentication
  //    if(authentication!==undefined){
  //   if(authentication.authToken!==''){
  // // if this feature is to get implemented in the future, you have to look into option that won't have jwt. Because the backend secret is removed from frontend from this point in time.
  //     jwt.verify(authentication.authToken,process.env.REACT_APP_BACKEND_SECRET,function(err) {
  //       if(err){
  //         setIsVerifyLogin(true)
  //           setLogin(false)
  //         history.push("/sign-in")
  //       }
  //       else{
  //         sessionStorage.setItem('authentication', JSON.stringify(authentication))
  //         setLogin(true)
  //         props.getuserDetail(authentication.user_id,authentication.authToken)
  //           .then(success=>{
  //               saveUserDetail({authToken:authentication.authToken,...success.value.data[0]}).then(res=>{

  //               })
  //           })
  //           .catch(err=>{console.log('err',err)})
  //           pathName[1]!=='sign-in'&&pathName[1]!==''? history.push(`/${pathName[1]}`):history.push(`/patients`)
  //           setIsVerifyLogin(false)
  //       }
  //     });
  //   }
  //   else{
  //     history.push("/sign-in")
  //     setLogin(false)
  //     setIsVerifyLogin(true)
  //   }
  // }
  //   }
  //   ,[])

  return (
    <div style={{ width: "100%", height: "100%" }}>
      {/* {isVerifyLogin?"":<SimpleLoader msg={"Verify Login"}/>} */}
      {/* {!login? */}
      <div className={classes.verifyLogin} id="verify-Login">
        <SimpleLoader msg={"Verify Login"} />
      </div>
      <div className={classes.root} id="main-content-section">
        <Topbar />
        <main className={classes.content}>{children}</main>
      </div>
      {/* // :""} */}
    </div>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
function mapStateToProps(store) {
  return {
    globalStore: store.globalStore,
    patientStore: store.patientStore,
    userStore: store.userStore,
  };
}
export default connect(mapStateToProps, {
  userLogin,
  getNetConnectivity,
  updateLoginModel,
})(withRouter(Minimal));
